import { Component, OnInit } from '@angular/core';
import {ItemManagerService} from "../../services/itemManager/item-manager.service";
import {ToolsService} from "../../services/toolsService/tools.service";
import {PerspectiveService} from "../../services/perspective/perspective.service";
declare var Yiit;

@Component({
  selector: 'app-perspectives',
  templateUrl: './perspectives.component.html',
  styleUrls: ['./perspectives.component.scss']
})
export class PerspectivesComponent implements OnInit {

  public perspectives: Object[];
  public Yiit = Yiit;

  constructor(private itemManagerService: ItemManagerService, private perspectiveService: PerspectiveService) {
    this.perspectives = window['PERSPECTIVES'];
  }

  ngOnInit() {
  }

  changePerspective(id) {

    this.perspectiveService.setCurrentPerspective(id);
    // if (id) {
    //   document.querySelectorAll('.perspective-category')
    //     .forEach(node => node['style']['display'] = (node.querySelector('.perspective-' + id) ? 'block' : 'none'));
    //   document.querySelectorAll('.perspective').forEach(node => node['style']['display'] = 'none');
    //   document.querySelectorAll('.perspective-' + id).forEach(node => node['style']['display'] = 'block');
    //   document.querySelectorAll('.perspective-category').forEach(node => node['style']['display'] = 'block');
    // } else {
    //   document.querySelectorAll('.perspective-category')
    //     .forEach(node => node['style']['display'] = 'block');
    //   document.querySelectorAll('.perspective')
    //     .forEach(node => node['style']['display'] = 'block');
    // }
  }

}
